import React , {useState } from "react";
import { useSelector } from 'react-redux'
import 'moment/locale/es';
import { Button, Card, CardHeader, CardBody, FormGroup, Form, Row, Col, } from "reactstrap";
import AsyncSelect from 'react-select/async';
import Select from "react-select";

var personasApi = require ('../api');

var Utils = require ('Utils') ;
var Const = require ('Const') ;

export const  AddRelativeCard = ( { personaID, addRelated, closeMe , isMyProfile } ) => {

  const [inputValue, setValue] = useState('');
  const [selectedValue, setSelectedValue] = useState(null);
  const [relation, setRelation] = useState('3');
 

  const { token, isSaving } = useSelector(state => ({
    token: state.auth.session.jwt_token, 
    isSaving: state.view.loadingModules.enrollingStudent 

   }))

    // handle input change event
    const handleInputChange = value => {
      setValue(value);
    };

   // handle selection
   const handleChange = value => {
    setSelectedValue(value);
    
    }
 


  const confirmAddRelation = () => {
    if (selectedValue) { 
      addRelated (token, personaID, selectedValue.persona_id, relation, isMyProfile, selectedValue)
      closeMe(false)
    }
  }


    // load options using API call
    const loadOptions = (inputValue) => {

      if (inputValue.length >= 3 ) return personasApi.searchPersona ( token, inputValue ).then(res => res );
    };

        return (
          
        <>
        <Card>
                <CardHeader>
                  <Row>
                    <Col className="pr-1" md="12">
                      <h5 className="title">Agregar contacto</h5>
                    </Col>
                  </Row>
                </CardHeader>
                
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="pr-1" md="12">
                        <FormGroup>
                          <AsyncSelect
                              cacheOptions
                              defaultOptions
                              value={selectedValue}
                              getOptionLabel={e => Utils.capitalize( e.last_name + ", " + e.name + " ( " + e.doc_type + ": " + e.doc_nbr + ")"  ) }
                              getOptionValue={e => e.persona_id}
                              loadOptions={loadOptions}
                              onInputChange={handleInputChange}
                              onChange={handleChange}
                              placeholder="Ingrese apellido ... "
                              noOptionsMessage={e => { return (<> No se encontro  <b>{inputValue}</b> </>) } }
                              loadingMessage={e => { if (inputValue.length >= 3 )
                                                        return "Buscando ... "
                                                        else return "ingrese al menos 3 letras del apellido para buscar"
                                                    }
                                              }
                            />
                            {selectedValue &&
                              <>
                              <br /><br />
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="nationality"
                                defaultValue={Const.getObjectByValue(Const.RELATIONS_TYPES, relation )}
                                onChange={(sel) => setRelation(sel.value) }
                                options={Const.RELATIONS_TYPES}
                                placeholder="Seleccione relación"
                              />
 
                              <Button color="success" size="sm" disabled={isSaving}
                                onClick={() => confirmAddRelation()}>
                              {isSaving?
                                <i className="nc-icon nc-refresh-69  fa-spin" />
                              :
                              <>
                                <span className="btn-label">
                                  <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                </span>
                                Confirmar contacto
                              </>
                              }
                              </Button>
                            </>
                            }

                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              </>
          );
    }

    // 